import { useTheme } from '@mui/material/styles';
function NRCircleHighIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.severityPalette[4].main;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7072 12.7071L15.293 14.1213L12.0001 10.8284L8.70718 14.1213L7.29297 12.7071L12.0001 8L16.7072 12.7071Z"
        fill={iconColor}
      />
    </svg>
  );
}

export default NRCircleHighIcon;
